export default __webpack_public_path__ + "static/media/icon-24-icn-notification-active.9a7cf9ae.svg";